export const TEXT_SIZES = {
  xxs: '16px',
  xs: '20px',
  sm: '24px',
  md: '32px',
  lg: '48px',
};
